import { RouterProvider as ReactRouterProvider } from 'react-router/dom';

import { useMaintenanceMode } from '~/hooks/useMaintenanceMode';
import { MaintenanceScreen } from '~/pages/_Root/MaintenanceScreen';

import { router } from './router';

export const RouterProvider = () => {
  const isMaintenanceMode = useMaintenanceMode();

  if (isMaintenanceMode) return <MaintenanceScreen />;

  return <ReactRouterProvider router={router} />;
};
